/**
 * Normalize user-entered portal / external links so bare domains open off-site,
 * not as SPA-relative paths (e.g. "google.com" → "https://google.com").
 */
export function normalizeExternalUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return trimmed;

  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }

  if (trimmed.startsWith('/') || trimmed.startsWith('#')) {
    return trimmed;
  }

  return `https://${trimmed}`;
}
